import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import imageCompression from "browser-image-compression";

import { createAccount, getAllCategories, getDepartements, getProductBySubCategorie, getRegions } from '../../lib/apis'
import { CirclePlus, Loader2 } from 'lucide-react'
import { MONTH, scrollToTop } from '../../lib/utils'
import { ProducteurInterface } from '../../lib/Interfaces/Producteur.interface'
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';

interface ValidationResult {
    isValid: boolean;
    errors: Partial<Record<keyof ProducteurInterface, string>>;
}
function Add_Producteur() {
    const { t, i18n } = useTranslation()
    const [regions, setRegions] = useState([])
    const fileInputRef = useRef<any>(null);
    const fileInputRef2 = useRef<any>(null);
    const [errors, setErrors] = useState<ValidationResult['errors']>()
    const [base64Image, setBase64Image] = useState<string[]>(["", ""]);
    const [producteur, setProducteur] = useState<ProducteurInterface>({
        nom_complet: "",
        phone_number: "",
        region: "",
        region_id: "",
        departement: "",
        departement_id: "",
        city: "",
        arrondissement_id: "",
        address: "",
        numero_cni: "",
        documents_base64: [],
        activies: []
    })
    const currentDate = new Date()
    const [loading, setLoading] = useState(false)
    const [departements, setDepartements] = useState([])
    const [subCategorie, setSubtCategorie] = useState([])
    const [arrondissements, setArrondissements] = useState([])
    const [products, setProducts] = useState([])
    const [load, setLoad] = useState(false)
    const [allDataSubCat, setAllDataSubCat] = useState<any>()
    const [allDataCat, setAllDataCat] = useState<any>()
    const navigate = useNavigate()
    const [activites, setActivites] = useState([
        {
            id: currentDate.getTime(),
            category_id: "",
            sub_category_id: "",
            superficie: "",
            speculation: "",
            periodicité: "",
            espece: "",
            nombre_espece: "",
        }
    ])
    const [categories, setCategories] = useState([])
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        scrollToTop()
    }, [])

    const newActivite = () => {
        setActivites([...activites, {
            id: currentDate.getTime(),
            category_id: "",
            sub_category_id: "",
            superficie: "",
            speculation: "",
            periodicité: "",
            espece: "",
            nombre_espece: "",
        }])
    }

    const updateCategories = async () => {
        setLoader(true)
        const currentLanguage = i18n.language
        console.log("currentLanguage", currentLanguage)
        try {
            const { data } = await axios.get(`${getAllCategories}`)
            setAllDataCat(data)
            console.log("data", data)
            if (currentLanguage === "fr") {
                setCategories(data.data)
            } else {
                setCategories(data.dataE)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }
    useEffect(() => {
        updateCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        const currentLanguage = i18n.language
        if (allDataCat) {
            if (currentLanguage === "fr") {
                setCategories(allDataCat.data)

            } else {
                setCategories(allDataCat.dataE)

            }
        }
        if (allDataSubCat) {
            if (currentLanguage === "fr") {
                setSubtCategorie(allDataSubCat.data)
            } else {
                setSubtCategorie(allDataSubCat.dataE)
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language])
    const handleChangeCategorie = async (id: number) => {
        const currentLanguage = i18n.language
        try {
            const { data } = await axios.get(`${getAllCategories}/${id}/subcategories`)
            if (data.data.length === 0) {
                console.log(data.message)
                console.log(data)
                setSubtCategorie([])
                return
            }
            setAllDataSubCat(data)
            if (currentLanguage === "fr") {
                setSubtCategorie(data.data)
            } else {
                setSubtCategorie(data.dataE)
            }
        } catch (error) {
            setSubtCategorie([])
            console.log(error)
        }
    }

    const handleChangeSubCategorie = async (id: number) => {
        try {
            const { data } = await axios.get(`${getProductBySubCategorie}/${id}`)
            setProducts(data.products ? data.products : [])
        } catch (error) {
            console.log(error)
        }
    }

    const updatRegions = async () => {
        setLoading(true)
        try {
            const { data } = await axios.get(`${getRegions}`)
            // console.log(data)
            setRegions(data.regions)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)

        }
    }
    useEffect(() => {
        updatRegions()
    }, [])
    const handleRegionChange = async (id: number) => {
        try {
            const { data } = await axios.get(`${getRegions}/${id}/departements`)
            setDepartements(data.departements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleDepartmentChange = async (id: number) => {
        try {
            const { data } = await axios.get(`${getDepartements}/${id}/arrondissements`)
            setArrondissements(data.arrondissements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleChange = (id: number, event: any) => {
        const { name, value } = event.target
        setActivites((prev) =>
            prev.map((activite) =>
                activite.id === id
                    ? {
                        ...activite,
                        [name]: value
                    } :
                    activite
            )
        )
    }
    const handleButtonClick = (index: number) => {
        if (index === 0) {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        } else {
            if (fileInputRef2.current) {
                fileInputRef2.current.click();
            }
        }

    };

    const handleChangeProducteur = (key: keyof ProducteurInterface, e: any) => {
        setProducteur({
            ...producteur,
            [key]: e.target.value
        })
    }


    const handleFileChange = async (index: number, e: any) => {
        // console.log(index)
        const file = e.target.files[0];
        if (!file) return;

        try {
            const options = {
                maxSizeMB: 0.5,         // taille max en mégaoctets
                maxWidthOrHeight: 800,  // dimension max en px
                useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);

            const base64 = await imageCompression.getDataUrlFromFile(compressedFile);
            const tmpBase = [...base64Image]
            tmpBase[index] = base64
            setBase64Image([...tmpBase]);
        } catch (error) {
            console.error("Erreur de compression :", error);
        }
    };


    function validateUserData(data: ProducteurInterface): ValidationResult {
        const errors: ValidationResult['errors'] = {};
        let isValid = true;
        data.documents_base64 = base64Image
        data.activies = activites

        // Validation du nom complet
        if (!data.nom_complet || data.nom_complet.trim().length === 0) {
            errors.nom_complet = "error_nom";
            isValid = false;
        } else if (data.nom_complet.length < 3) {
            errors.nom_complet = "error_taille_name";
            isValid = false;
        }

        // Validation du numéro de téléphone
        const phoneRegex = /^(?:(?:\+|00)221|0)?[67]\d{8}$/; // Format pour numéros sénégalais
        if (!data.phone_number) {
            errors.phone_number = "error_phone";
            isValid = false;
        } else if (!phoneRegex.test(data.phone_number)) {
            errors.phone_number = "error_taille_phone";
            isValid = false;
        }

        // Validation de la région
        if (!data.region) {
            errors.region = "error_region";
            isValid = false;
        }

        // Validation du département
        if (!data.departement) {
            errors.departement = "error_departement";
            isValid = false;
        }

        // Validation de la ville
        if (!data.city) {
            errors.city = "error_city";
            isValid = false;
        }

        // Validation de l'adresse
        if (!data.address || data.address.trim().length === 0) {
            errors.address = "error_address";
            isValid = false;
        } else if (data.address.length < 5) {
            errors.address = "error_taille_address";
            isValid = false;
        }

        // Validation du numéro de CNI
        if (!data.numero_cni) {
            errors.numero_cni = "error_cni";
            isValid = false;
        } else if (data.numero_cni.length < 9) {
            errors.numero_cni = "error_taille_cni";
            isValid = false;
        }

        // Validation des documents
        if (data.documents_base64[0] === "" || data.documents_base64[1] === "") {
            errors.documents_base64 = "error_document";
            isValid = false;
        } else if (data.documents_base64.length > 5) {
            errors.documents_base64 = "error_taille_documenet";
            isValid = false;
        }

        // Validation des activités (optionnelle)
        if (data.activies[0].category_id === "" || data.activies[0].sub_category_id === "") {
            errors.activies = "error_activite";
            isValid = false;
        }

        return {
            isValid,
            errors
        };
    }
    const handleSubmit = async () => {
        // console.log(producteur);

        console.log(producteur.phone_number.includes("+237"))
        console.log("base64Image", producteur)
        const validation = validateUserData(producteur);
        if (!validation.isValid) {
            console.log(validation.errors)
            setErrors(validation.errors)
            if (validation.errors?.nom_complet) {
                toast.error(t(validation.errors?.nom_complet || ""))
                return
            }
            if (validation.errors?.phone_number) {
                toast.error(t(validation.errors?.phone_number || ""))
                return
            }
            if (validation.errors?.region) {
                toast.error(t(validation.errors?.region || ""))
                return
            }
            if (validation.errors?.departement) {
                toast.error(t(validation.errors?.departement || ""))
                return
            }
            if (validation.errors?.city) {
                toast.error(t(validation.errors?.city || ""))
                return
            }
            if (validation.errors?.address) {
                toast.error(t(validation.errors?.address || ""))
                return
            }
            if (validation.errors?.numero_cni) {
                toast.error(t(validation.errors?.numero_cni || ""))
                return
            }
            if (validation.errors?.documents_base64) {
                toast.error(t(validation.errors?.documents_base64 || ""))
                return
            }
            if (validation.errors?.activies) {
                toast.error(t(validation.errors?.activies || ""))
                return
            }
            return
        }
        try {
            setLoad(true)
            await axios.post(createAccount, {
                ...producteur,
                phone_number: producteur.phone_number.includes("+237") ? producteur.phone_number : `+237${producteur.phone_number}`,
                documents_base64: base64Image,
                activies: activites
            })
            toast.success(t("compte_creer"))
            setProducteur({
                nom_complet: "",
                phone_number: "",
                region: "",
                region_id: "",
                departement: "",
                departement_id: "",
                city: "",
                arrondissement_id: "",
                address: "",
                numero_cni: "",
                documents_base64: [],
                activies: []
            })
            setDepartements([])
            setArrondissements([])
            setBase64Image(["", ""])
            setActivites([
                {
                    id: currentDate.getTime(),
                    category_id: "",
                    sub_category_id: "",
                    superficie: "",
                    speculation: "",
                    periodicité: "",
                    espece: "",
                    nombre_espece: "",
                }
            ])
        } catch (error: any) {
            console.log(error)
            if (error.response) {
                toast.error(i18n.language === "fr" ? error.response?.data.message : error.response?.data.messageE)
            }

        } finally {
            setLoad(false)
        }
    }
    return (
        <div className='flex flex-col w-full py-5 justify-center'>
            <div className="flex flex-row py-5  items-center justify-start w-full ml-10">

                <Breadcrumb />
            </div>
            <div className='mb-10'>
                <h1 className='text-2xl text-center font-bold'>{t("devenir_producteur")}</h1>
                <h2 className=' text-center font-normal'>{t("proposez_produit")}</h2>
            </div>
            <div className='flex shadow-xl shadow-slate-800 flex-col justify-center md:justify-between p-5 mx-auto w-[80%] border '>
                <div className='flex flex-col md:flex-row justify-between gap-5'>
                    <div className=' w-[80%] md:w-[40%]'>
                        <div className='flex flex-col gap-2'>
                            <label htmlFor="nom">{t("nom")}</label>
                            <input value={producteur.nom_complet} onChange={(e) => handleChangeProducteur("nom_complet", e)} type="text" className={` ${errors?.nom_complet ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("nom_placeholder")} />
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.nom_complet || "")}</p>
                        </div>
                        <div className='mt-4 flex flex-col gap-2'>
                            <label htmlFor="phone">{t("telephone")}</label>
                            <input value={producteur.phone_number} className={` ${errors?.phone_number ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} onChange={(e) => handleChangeProducteur("phone_number", e)} type="text" placeholder={t("phone_placeholder")} />
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.phone_number || "")}</p>
                        </div>
                        <h2 className='font-normal mt-10'>{t("lieu_residence")}</h2>
                        <div className='border-2 p-5 rounded-sm'>
                            {loading ? <div>{t("chargement")}</div> :
                                <div className='mt-4 flex flex-col gap-2'>
                                    <select onChange={(e) => {
                                        handleRegionChange(Number(e.target.value))
                                        handleChangeProducteur("region", e)
                                        // handleChangeProducteur("region_id", e)
                                    }} className={`${errors?.region ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="region" id="region">
                                        <option value="">{t("select_region")}</option>
                                        {regions.map((region: any) => (
                                            <option key={region.id} value={region.region_id}>{i18n.language === "fr" ? region.region_name : region.region_name_en}</option>
                                        ))}
                                    </select>
                                    <p className='text-red-500 text-[10px] font-sans'>{t(errors?.region || "")}</p>
                                </div>}
                            <div className='mt-4 flex flex-col gap-2'>
                                <select onChange={(e) => {
                                    handleDepartmentChange(Number(e.target.value))
                                    handleChangeProducteur("departement", e)
                                    // handleChangeProducteur("departement_id", e)
                                }} className={` ${errors?.departement ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="departement" id="departement">
                                    <option value="">{t("select_departement")}</option>
                                    {departements.map((departement: any) => (
                                        <option key={departement.id} value={departement.departement_id}>{i18n.language === "fr" ? departement.departement_name : departement.departement_name_en}</option>
                                    ))}
                                </select>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.departement || "")}</p>
                            </div>
                            <div className='mt-4 flex flex-col gap-2'>
                                <select onChange={(e) => {
                                    handleChangeProducteur("city", e)
                                    // handleChangeProducteur("arrondissement_id", e)
                                }
                                } className={` ${errors?.city ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="arrondissement" id="arrondissement">
                                    <option value="">{t("select_arrondissement")}</option>
                                    {arrondissements.map((arrondissement: any) => (
                                        <option key={arrondissement.id} value={arrondissement.arrondissement_id}>{i18n.language === "fr" ? arrondissement.arrondissement_name : arrondissement.arrondissement_name_en}</option>
                                    ))}
                                </select>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.city || "")}</p>
                                {/* <label htmlFor="nom">{t("arrondissement")}</label>
                            <input type="text" className='border-2 p-2 rounded-sm' placeholder={t("phone_placeholder")} /> */}
                            </div>
                            <div className='mt-4 flex flex-col gap-2'>
                                <label htmlFor="Address">{t("address")}</label>
                                <input value={producteur.address} onChange={(e) => handleChangeProducteur("address", e)} type="text" className={` ${errors?.address ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("address_placeholder")} />
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.address || "")}</p>
                            </div>
                        </div>
                        <div className='mt-5 mb-3'>{t("doc_justificatif")}</div>
                        <div className='border-2 p-4'>
                            <div className='flex flex-col gap-2'>
                                <label htmlFor="Cni">{t("num_cni")}</label>
                                <input value={producteur.numero_cni} onChange={(e) => handleChangeProducteur("numero_cni", e)} type="text" className={` ${errors?.numero_cni ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("num_cni")} />
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.numero_cni || "")}</p>
                                <div className='flex mt-3 justify-between'>
                                    <button onClick={() => handleButtonClick(0)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        <input onChange={(e) => handleFileChange(0, e)} ref={fileInputRef} type="file" accept="image/*" hidden />
                                        {base64Image[0] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img src={base64Image[0]} alt="vector" />}
                                        <p className='text-[10px] mt-3 '>{t("cni_recto")}</p>
                                    </button>
                                    <button onClick={() => handleButtonClick(1)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        <input onChange={(e) => handleFileChange(1, e)} ref={fileInputRef2} type="file" accept="image/*" hidden />
                                        {base64Image[1] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img src={base64Image[1]} alt="vector" />}
                                        <p className='text-[10px] mt-3'>{t("cni_verso")}</p>
                                    </button>

                                </div>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.documents_base64 || "")}</p>
                            </div>
                        </div>
                    </div>
                    <div className=' w-[80%] md:w-[40%]'>
                        <div className=' flex flex-row justify-between mb-2' >
                            {t("mon_activite")}
                            <button onClick={newActivite}>
                                <CirclePlus color='#CE181E' size={20} />
                            </button>
                        </div>
                        {activites.map((activite, index) => {
                            return (
                                <div key={activite.id} className={` ${errors?.activies ? "border-red-600" : "border-gray-200"} flex mt-2 flex-col gap-2 border-2 p-2 rounded-sm`}>
                                    <div className=' flex flex-col gap-2'>
                                        <p>{t("categorie")}</p>
                                        <select onChange={(e) => {
                                            handleChangeCategorie(Number(e.target.value))
                                            handleChange(activite.id, e)
                                        }

                                        } className='border-2  p-2 rounded-sm' name="category_id" id="categorie">
                                            <option value="">{loader ? t("chargement...") : t("categorie")}</option>
                                            {!loader && categories.map((categorie: any) => (
                                                <option key={categorie.category_id} value={categorie.category_id}>{categorie.category_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='mt-4 flex flex-col gap-2'>
                                        <p>{t("sub_Categorie")}</p>
                                        <select onChange={(e) => {
                                            handleChangeSubCategorie(Number(e.target.value))
                                            handleChange(activite.id, e)
                                        }} className='border-2 p-2 rounded-sm' name="sub_category_id" id="sub_Categorie">
                                            <option value="">{loader ? t("chargement...") : t("sub_Categorie")}</option>
                                            {subCategorie.map((subcategorie: any) => (
                                                <option key={subcategorie.sub_category_id} value={subcategorie.sub_category_id}>{subcategorie.sub_category_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='mt-4 flex flex-col gap-2'>
                                        {activites[index].category_id === "1" && <>
                                            <p>{t("speculation")}</p>
                                            <select onChange={(e) => {
                                                // handleChangeSubCategorie(Number(e.target.value))
                                                handleChange(activite.id, e)
                                            }} className='border-2 p-2 rounded-sm' name="speculation" id="speculation">
                                                <option value="">{loader ? t("chargement...") : t("speculation")}</option>
                                                {products.map((product: any) => (
                                                    <option key={product.product_id} value={product.product_name}>{i18n.language === "fr" ? product.product_name : product.product_name_en}</option>
                                                ))}
                                            </select>
                                        </>}
                                        {activites[index].category_id === "2" && <>   <p>{t("especes")}</p>
                                            <select onChange={(e) => {
                                                // handleChangeSubCategorie(Number(e.target.value))
                                                handleChange(activite.id, e)
                                            }} className='border-2 p-2 rounded-sm' name="espece" id="speculation">
                                                <option value="">{loader ? t("chargement...") : t("especes")}</option>
                                                {products.map((product: any) => (
                                                    <option key={product.product_id} value={product.product_name}>{i18n.language === "fr" ? product.product_name : product.product_name_en}</option>
                                                ))}
                                            </select>
                                        </>}
                                    </div>
                                    <div className='mt-4 flex flex-col gap-2'>
                                        {activites[index].category_id === "1" &&
                                            <>
                                                <p>{t("periodicite_saisoniaire")}</p>
                                                <select onChange={(e) => {
                                                    handleChangeSubCategorie(Number(e.target.value))
                                                    handleChange(activite.id, e)
                                                }} className='border-2 p-2 rounded-sm' name="periodicité" id="periodicite_saisoniaire">
                                                    <option value="">{loader ? t("chargement...") : t("periodicite_saisoniaire")}</option>
                                                    {MONTH.map((product: any) => (
                                                        <option key={product.id} value={product.name}>{product.name}</option>
                                                    ))}
                                                </select>
                                            </>
                                        }
                                        {activites[index].category_id === "2" &&
                                            <>
                                                <p>{t("periodicite_activite")}</p>
                                                <input type="text" name='periodicité' onChange={(e) => handleChange(activite.id, e)} className='border-2 p-2 rounded-sm' placeholder={t("activite_placeHolder")} />
                                            </>
                                        }
                                    </div>
                                    {activites[index].category_id === "1" &&
                                        <div className='mt-4 flex flex-col gap-2'>
                                            <label htmlFor="superficie">{t("superficie")}</label>
                                            <input type="text" name='superficie' onChange={(e) => handleChange(activite.id, e)} className='border-2 p-2 rounded-sm' placeholder={t("superficie_placeholder")} />
                                        </div>}
                                    {activites[index].category_id === "2" &&
                                        <div className='mt-4 flex flex-col gap-2'>
                                            <label htmlFor="nom">{t("nombre_espece")}</label>
                                            <input type="text" name='nombre_espece' onChange={(e) => handleChange(activite.id, e)} className='border-2 p-2 rounded-sm' placeholder={t("nombre_espece")} />
                                        </div>}
                                </div>
                            )
                        })}
                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.activies || "")}</p>
                    </div>
                </div>

                <button disabled={load} onClick={() => handleSubmit()} className='bg-[#15803D] text-white p-3 rounded-3xl mt-10 w-[70%] mx-auto hover:bg-[#15803D]/80 transition-all duration-300 ease-in-out'>
                    {load ? <div className='w-[100%] flex items-center justify-center' ><Loader2 /></div> : t("envoyer_demande")}
                </button>
            </div>
        </div>
    )
}

export default Add_Producteur